<template>
<confirm-base @showErrorModal="$emit('showErrorModal', $event)" @showLoginModal="$emit('showLoginModal', $event)">
  <template scope="prop">
    <div class="form-group p-3">
      <label for="PhotoTitle" co-3>撮影会名・タイトル<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.event_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoTeacher">講師名（活動名）<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.lecturer_name }} 先生</p>
    </div>
    <div class="form-group p-3">
      <label for="Photo-date-input" class="col-form-label">開催日<span class="attention">※</span></label>
      <pre class="font-weight-bold">{{ prop.item.event_date }}</pre>
    </div>
    <div class="form-group p-3">
      <label for="Photo-date-public-input" class="col-form-label">開催日(一覧表示用)<span class="attention">※</span></label>
      <pre v-if="prop.item.event_date_public" class="font-weight-bold">{{ prop.item.event_date_public }}</pre>
      <pre v-else class="font-weight-bold">{{ prop.item.event_date_public_multi }}</pre>
      <pre v-if="!prop.item.event_date_public" class="font-weight-bold">開催日の23:59まで掲載されます。</pre>
    </div>
    <div v-if="prop.item.event_date_public" class="form-group p-3">
      <label for="Photo-dateEnd-input" class="col-form-label">掲載終了日<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.endDate }}</p>
    </div>
    <div class="form-group p-3">
      <p for="PhotoPlace">開催場所・住所<span class="attention">※</span></p>
      <p class="font-weight-bold">{{ prop.fullAddress }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoP_name">会場名</label>
      <p class="font-weight-bold">{{ prop.item.venue.venue_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoTel">問い合わせ先電話番号</label>
      <p class="font-weight-bold">{{ prop.item.inquiry.tel }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoMail">問い合わせ先メールアドレス<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.inquiry.email }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoURL">会場ホームページ（アクセス方法）</label>
      <p class="font-weight-bold">{{ prop.item.venue.homepage }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoBlog">講師ホームページ・ブログ記事URL</label>
      <p class="font-weight-bold">{{ prop.item.lecturer_url }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoDes">撮影会詳細<span class="attention">※</span></label>
      <pre class="font-weight-bold">{{ prop.item.description }}</pre>
    </div>
    <div class="form-group p-3">
      <label for="PhotoDes">参加費<span class="attention">※</span></label>
      <div class="input-group">
        <pre class="font-weight-bold">{{ prop.item.fee }}</pre>
      </div>
    </div>
    <div class="form-group p-3">
      <label for="AppURL">お申し込みURL</label>
      <p class="font-weight-bold">{{ prop.item.entry_url }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoParking">駐車場有無</label>
      <p class="font-weight-bold">{{ prop.item.parking }}</p>
    </div>
    <div class="form-group p-3">
      <label for="LineAt">LINE@</label>
      <p class="font-weight-bold">{{ prop.item.line_at }}</p>
    </div>
    <div class="form-group p-3">
      <label for="PhotoInputFile">撮影会画像アップロード</label>
      <div class="row">
        <image-item v-for="f in prop.item.images.filter(i => i !== '')" :key="f" :image="f"/>
      </div>
    </div>
    <div class="form-group p-3">
      <label for="PhotoPublish">公開設定<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.published }}</p>
    </div>
  </template>
</confirm-base>
</template>

<script>
import ConfirmBase from '../ConfirmBase.vue'
import ImageItem from 'components/lecturer/ImageItem'
export default {
  components: {
    ConfirmBase,
    ImageItem
  }
}
</script>



// WEBPACK FOOTER //
// PhotoConfirm.vue?ebee21be